export default "__VITE_ASSET__CfK3ekB9__"